<template>
  <div class="satisfactionSurvey">
    <van-sticky>
      <div class="header-H">
        <van-icon name="arrow-left" color="#fff" class="vanIcon" />
        <span class="addInfo">问卷调查</span>
      </div>
    </van-sticky>
    <div>
      <p class="title">
        <van-icon name="warning" size="0.75rem" />
        <span>请您为我们科室提出真诚的意见和建议，以利我们改进工作，更好地为您提供优质，安全、快捷的高品质医疗美容服务!</span>
      </p>
      <van-field name="radio" label="1.您对我院皮微科室环境,设施,卫生等是否让您觉得满意?">
        <template #input>
          <van-radio-group v-model="form.radio" direction="horizontal">
            <van-radio name="A">A 很满意</van-radio>
            <van-radio name="B">B 满意</van-radio>
            <van-radio name="C">C 一般</van-radio>
            <van-radio name="D">D 不满意</van-radio>
            <van-radio name="E">E 很不满意</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field name="radio" label="2.您对本次皮微前台安排治疗的服务效率和服务态度是否满意?">
        <template #input>
          <van-radio-group v-model="form.radio1" direction="horizontal">
            <van-radio name="A">A 很满意</van-radio>
            <van-radio name="B">B 满意</van-radio>
            <van-radio name="C">C 一般</van-radio>
            <van-radio name="D">D 不满意</van-radio>
            <van-radio name="E">E 很不满意</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field name="radio" label="3.您对本次美容师的解释，交流，服务内容满意么?">
        <template #input>
          <van-radio-group v-model="form.radio2" direction="horizontal">
            <van-radio name="A">A 很满意</van-radio>
            <van-radio name="B">B 满意</van-radio>
            <van-radio name="C">C 一般</van-radio>
            <van-radio name="D">D 不满意</van-radio>
            <van-radio name="E">E 很不满意</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field name="radio" label="4.您对本次接待的咨询人员服务态度是否满意?">
        <template #input>
          <van-radio-group v-model="form.radio3" direction="horizontal">
            <van-radio name="A">A 很满意</van-radio>
            <van-radio name="B">B 满意</van-radio>
            <van-radio name="C">C 一般</van-radio>
            <van-radio name="D">D 不满意</van-radio>
            <van-radio name="E">E 很不满意</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field name="radio" label="5.您对本次治疗医生的诊疗技术和服务态度是否满意?">
        <template #input>
          <van-radio-group v-model="form.radio4" direction="horizontal">
            <van-radio name="A">A 很满意</van-radio>
            <van-radio name="B">B 满意</van-radio>
            <van-radio name="C">C 一般</van-radio>
            <van-radio name="D">D 不满意</van-radio>
            <van-radio name="E">E 很不满意</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field name="radio" label="6.您对本次治疗后注意事项是否已告知并了解清楚?">
        <template #input>
          <van-radio-group v-model="form.radio5" direction="horizontal">
            <van-radio name="A">A 已告知</van-radio>
            <van-radio name="B">B 未告知</van-radio>
            <van-radio name="C">C 清楚</van-radio>
            <van-radio name="D">D 不清楚</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field v-model="form.message" rows="1" autosize label="7.感谢您百忙中给与如实评价，在我们的本次服务过程中，您认为我们哪些工作仍需改进提升，望提出宝贵意见!" type="textarea" placeholder="请输入宝贵意见..." />
      <div class="phoneStyle">
        <van-field v-model="form.mobile" type="tel" left-icon="phone-o" placeholder="请输入手机号" maxlength="11" />
      </div>
      <div class="addProject" @click="sureSubmit">提交</div>
    </div>
  </div>
</template>
<script>
import { Dialog } from 'vant';
import { createQuesttionniare, } from "@/axios/api";
export default {
  data() {
    return {
      form: {
        radio: '',
        radio1: '',
        radio2: '',
        radio3: '',
        radio4: '',
        radio5: '',
      },
      userId: ''
    }
  },
  methods: {
    sureSubmit() {
      console.log('提交')
      if (this.form.radio == '' || this.form.radio1 == '' || this.form.radio2 == '' || this.form.radio3 == '' || this.form.radio4 == '' || this.form.radio5 == '') {
        Dialog.alert({
          message: '请填写完整信息',
          confirmButtonColor: '#108EE9'
        }).then(() => {

        }).catch(() => {
        });
        return;
      }
      this.userId = JSON.parse(localStorage.getItem('userInfo')).empId
      var dataList = {
        mobile: this.form.mobile,
        userId: this.userId,
        remark: this.form.message,
        questionnaireSubject: [
          {
            subjectOrder: 1,
            answer: this.form.radio
          },
          {
            subjectOrder: 2,
            answer: this.form.radio1
          },
          {
            subjectOrder: 3,
            answer: this.form.radio2
          },
          {
            subjectOrder: 4,
            answer: this.form.radio3
          },
          {
            subjectOrder: 5,
            answer: this.form.radio4
          },
          {
            subjectOrder: 6,
            answer: this.form.radio5
          },
        ],
        questionnaireType: 1
      }
      createQuesttionniare(dataList)
        .then((res) => {
          if (res.result == true) {
            Dialog.alert({
              message: '问卷新增成功',
              confirmButtonColor: '#108EE9'
            }).then(() => {
              location.reload();
            }).catch(() => {
            });
          } else {
            this.$toast.fail(err.errMsg);
          }
        })
        .catch((err) => {
          this.$toast.fail(err.errMsg);
        });
    }
  }
}
</script>
<style scoped>
.satisfactionSurvey >>> .van-cell {
  flex-direction: column;
  border-radius: 10px;
  width: 94%;
  margin: 0 auto;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(51, 66, 87, 0.3);
  border-radius: 10px;
  margin-bottom: 1.25rem;
}
.satisfactionSurvey >>> .van-radio-group--horizontal {
  flex-direction: column;
  width: 100%;
}
.satisfactionSurvey >>> .van-field__label {
  width: 100%;
}
.phoneStyle >>> .van-field__label {
  width: 30%;
}
.phoneStyle >>> .van-cell {
  flex-direction: row;
}
.phoneStyle >>> .van-radio-group--horizontal {
  flex-direction: row;
}
.satisfactionSurvey >>> .header-H {
  background: linear-gradient(160deg, #1fdbcf 0%, #1bcaca 12%, #0164a8 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 4rem;
  padding-top: 10px;
  box-sizing: border-box;
}

.satisfactionSurvey >>> .vanIcon {
  position: absolute;
  left: 1.3rem;
}
.satisfactionSurvey >>> .addProject {
  width: 94%;
  height: 2.5rem;
  margin: 0 auto;
  background: linear-gradient(118deg, #0297ce 0%, #0164a8 100%);
  border-radius: 1.875rem;
  text-align: center;
  line-height: 2.5rem;
  font-size: 1rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  margin-bottom: 1rem;
}
.satisfactionSurvey >>> .title {
  font-size: 0.75rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(1, 100, 168, 0.56);
  width: 94%;
  margin: 1rem auto;
}
.satisfactionSurvey >>> .van-radio__label {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #050505;
  margin: 0.5rem 0 0.5rem 0.5rem;
  width: 100%;
}
.satisfactionSurvey >>> .van-radio__icon--checked .van-icon {
  width: 1.25rem;
  height: 1.25rem;
  background-color: #d9d9d9;
  border-radius: 50%;
  border: 0.35rem solid #0164a8;
}
.satisfactionSurvey >>> .van-icon-success::before {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/satisfactionSurvey.vue